/* global $ */

import SwapContents from "./SwapContents";

class AnimationSectionBlock {
  constructor(swapContents, $el) {
    this.swapContents   = swapContents;
    this.$el            = $el;
    this.top            = 0;
    this.height         = 0;
    this.index          = parseInt(this.$el.attr('data-index'));
  }
  onWindowResize() {
    this.top = parseInt(this.$el.offset()['top']);
    this.height = parseInt(this.$el.height());
  }
  update(scrollTop) {
    if(
      scrollTop > this.$el.offset()['top']
      && scrollTop < this.$el.offset()['top'] + (this.$el.height())
    ) {
      this.swapContents.blocks[this.index].update((scrollTop - this.top) / this.height);
      this.$el.attr('data-current', 'true');
    } else {
      this.swapContents.blocks[this.index].update(-1);
      this.$el.attr('data-current', 'false');
    }
  }
}

class AnimationSection {
  constructor(mainApp) {
    this.mainApp              = mainApp;
    this.isTouchDevice        = false;

    let touch_event           = window.ontouchstart;
    let touch_points          = navigator.maxTouchPoints;

    if( touch_event !== undefined && 0 < touch_points ) {
      this.isTouchDevice = true;
      $('body').addClass('is-touch-device');
    }

    this.$sequenceContainer   = $('.Sequence');
    this.$sectionContainer    = $('.AnimationSection');
    this.swapContents         = new SwapContents(this);

    this.canvas               = document.querySelector('#Sequence__canvas');
    this.ctx                  = this.canvas.getContext('2d');
    this.loadImageCount       = 0;
    this.currentPage          = 0;
    this.currentPagePrev      = -1;
    this.isShowText           = false;
    this.onLoadCompleteImages = false;
    this.images               = [];
    this.mediaQuery1000       = window.matchMedia('(max-width: 1000px)');
    this.mediaQuery           = window.matchMedia('(max-width: 800px)');
    this.animationBlocks      = [];
    this.currentDrawPosition  = 0;


    this.originalSize         = 1600;

    $('.AnimationSectionBlock').each((i, e) => {
      this.animationBlocks.push(new AnimationSectionBlock(this.swapContents, $(e)));
    });
  }

  destroy() {
    clearInterval(this.loadWaitInterval);
  }

  /*
  async loadImages() {
    this.swapContents.start();
    console.log('loadImages start');

    await this.asyncLoadImages();

    console.log('読み込み完了');
    // console.log('images : ', images);

    this.onLoadCompleteImages = true;
    this.draw(0);

    for(let i = 0; i < 4; i++) {
      this.animationBlocks[i].onWindowResize();
    }
  }
  */

  loadImages() {
    this.swapContents.start();

    let directoryName = 'sequence_jpg';
    if(window.innerWidth < 800) {
      this.originalSize = 750;
      directoryName = 'sequence_jpg_sp';
    }

    for(let i = 0; i < 480; i++) {
      if(i % 2 == 0) {
        let id = String(i + 1);
        if(id.length == 1) id = '00' + id;
        else if(id.length == 2) id = '0' + id;

        let img_src = window.url_template + `/assets/images/home/${directoryName}/metro_0322_web_a_0${id}.jpg`;
        let img = new Image();
        img.onload = () => {
          this.loadImageCount++;
        };
        img.src = img_src;
        this.images.push(img);
      }
    }

    for(let i = 0; i < 4; i++) {
      this.animationBlocks[i].onWindowResize();
    }

    this.loadWaitInterval = setInterval(() => {
      if(this.images.length == this.loadImageCount) {
        clearInterval(this.loadWaitInterval);

        this.onLoadCompleteImages = true;
        this.draw(this.currentDrawPosition);
        $('.AnimationSection').addClass('AnimationSection--on-load-complete');

        /*
        for(let i = 0; i < 4; i++) {
          this.animationBlocks[i].onWindowResize();
        }
        */
        this.mainApp.onWindowResize();
      }
    }, 1000 / 10);
  }

  draw(value) {
    this.currentDrawPosition = value;
    if(this.onLoadCompleteImages) {
      if(value < 0) value = 0;
      if(value > 1) value = 1;
      let targetIndex = parseInt(value * this.images.length);
      if(targetIndex >= this.images.length) targetIndex = this.images.length - 1;
      // console.log('描画インデックスは', targetIndex);

      this.ctx.drawImage(this.images[targetIndex],
        0,  // sx      (元画像の切り抜き始点X)
        0,  // sy      (元画像の切り抜き始点Y)
        this.originalSize,  // sWidth  (元画像の切り抜きサイズ：横幅)
        this.originalSize,  // sHeight (元画像の切り抜きサイズ：高さ)
          0,  // dx      (Canvasの描画開始位置X)
          0,  // dy      (Canvasの描画開始位置Y)
        800,  // dWidth  (Canvasの描画サイズ：横幅)
        800   // dHeight (Canvasの描画サイズ：高さ)
     );


    }

  }

  onWindowScroll(scrollTop) {
    let actionPosBegin = parseInt(this.$sectionContainer.offset()['top'] - (this.mainApp.windowHeight * 1));
    let actionPosEnd = parseInt(this.$sectionContainer.offset()['top'] + this.$sectionContainer.height() - (this.mainApp.windowHeight * 0.66));
    let actionRange = actionPosEnd - actionPosBegin;

    let isFadeinSwapContents = false;

    if(scrollTop < actionPosBegin) {
      this.draw(0);
      this.isShowText = false;
    } else if(scrollTop > actionPosEnd) {
      this.draw(1);
      this.isShowText = false;
    } else {
      this.isShowText = true;
      this.draw((scrollTop - actionPosBegin) / actionRange);
    }

    if(scrollTop > this.$sectionContainer.offset()['top'] - this.windowHeightHalf) {
      this.$sequenceContainer.addClass('-fadein');
      isFadeinSwapContents = true;
    } else {
      this.$sequenceContainer.removeClass('-fadein');
      isFadeinSwapContents = false;
    }

    if(scrollTop > this.$sectionContainer.offset()['top'] + this.$sectionContainer.height() - this.windowHeightHalf - this.canvasWidthHalf) {
      this.$sequenceContainer.addClass('Sequence--bottom');
      this.$sequenceContainer.css({
        'right': 0
      });
      isFadeinSwapContents = false;
    } else if(scrollTop > this.$sectionContainer.offset()['top'] - this.windowHeightHalf + this.canvasWidthHalf) {
      this.$sequenceContainer.removeClass('Sequence--bottom');
      this.$sequenceContainer.addClass('Sequence--center');
      this.$sequenceContainer.css({
        'right': this.mainApp.windowWidth - parseInt(this.$sectionContainer.offset()['left'] + this.$sectionContainer.width())
      });
    } else {
      this.$sequenceContainer.removeClass('Sequence--bottom');
      this.$sequenceContainer.removeClass('Sequence--center');
      this.$sequenceContainer.css({
        'right': 0
      });
    }
    if(isFadeinSwapContents) {
      this.swapContents.fadein();
    } else {
      this.swapContents.fadeout();
    }

    for(let i = 0; i < 4; i++) {
      this.animationBlocks[i].update(scrollTop);
    }

    this.currentPage = 0;
    for(let i = 0; i < 4; i++) {
      if(scrollTop > this.animationBlocks[3 - i].$el.offset()['top']) {
        this.currentPage = 3 - i;
        break;
      }
    }

    if(this.currentPagePrev != this.currentPage) {
      this.swapContents.change(this.currentPage);
    }
    this.currentPagePrev = this.currentPage;

  }

  onWindowResize() {
    this.windowHeight = window.innerHeight;
    this.windowHeightHalf = parseInt(this.windowHeight / 2);
    // this.canvasWidth = parseInt(this.$sectionContainer.width() / 1.6);

    for(let i = 0; i < 4; i++) {
      this.animationBlocks[i].onWindowResize();
    }

    if(this.mediaQuery.matches) {
      this.canvasWidth = document.documentElement.clientWidth - 80;
      // this.swapContents.checkState('sp');
    } else if(this.mediaQuery1000.matches) {
      this.canvasWidth = parseInt(window.innerWidth / 2);
      // this.swapContents.checkState('pc');
    } else {
      this.canvasWidth = parseInt(this.$sectionContainer.width() - 480);
      // this.swapContents.checkState('pc');
    }

    this.canvasWidthHalf = parseInt(this.canvasWidth / 2);

    this.$sequenceContainer.css({
      'width': this.canvasWidth,
      'height': this.canvasWidth
    });
  }

}
export default AnimationSection;
